module.exports = __webpack_public_path__ + "img/antes_despues_284.3cfb2ce3.png";